import { call, put, select } from 'redux-saga/effects';
import { teamsModel } from '../../../../features/teams';
import { RT } from '../../../../shared/types';
import { fathomApi } from '../../../../shared/api/axios/fathom';
import { fathomModel } from '..';
import { logger } from '../../../../shared/lib';

const TRANSCRIPTS_FETCH_MONTHS_PERIOD = 12;

export function* getFathomTranscripts() {
  const currentTeam: RT<
    typeof teamsModel.selectors.selectCurrentTeamWithError
  > = yield select(teamsModel.selectors.selectCurrentTeamWithError);

  if (!currentTeam.isFathomConnected) {
    return;
  }

  yield put(fathomModel.actions.setIsLoadingTranscripts(true));

  try {
    const date = new Date();
    date.setMonth(date.getMonth() - TRANSCRIPTS_FETCH_MONTHS_PERIOD);

    const transcriptsInfo: RT<typeof fathomApi.getTranscripts> = yield call(
      fathomApi.getTranscripts,
      currentTeam.id,
      date
    );

    yield put(
      fathomModel.actions.setParticipants(transcriptsInfo.participants)
    );

    yield put(fathomModel.actions.setTranscripts(transcriptsInfo.items));
  } catch (error) {
    logger.error(error);
  } finally {
    yield put(fathomModel.actions.setIsLoadingTranscripts(false));
  }
}
